'use client'

import { cn } from '@/core/lib/utils/cn'
import {
  Modal as HeroUiModal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalProps,
} from '@heroui/modal'

export const Modal = ({
  isOpen,
  onClose,
  children,
  className = '',
  hideCloseButton,
  disableBackdropDismiss,
  placement = 'center',
  size = 'md',
}: {
  isOpen?: boolean
  onClose?: () => void
  children: React.ReactNode
  className?: string
  hideCloseButton?: boolean
  disableBackdropDismiss?: boolean
  placement?: Pick<ModalProps, 'placement'>['placement']
  size?: Pick<ModalProps, 'size'>['size']
}) => {
  return (
    <HeroUiModal
      isOpen={isOpen}
      onClose={onClose}
      placement={placement}
      closeButton={!hideCloseButton}
      classNames={{
        closeButton: cn(hideCloseButton && 'hidden', 'cursor-pointer'),
        backdrop: 'bg-[#0F4471]/30',
      }}
      isDismissable={!disableBackdropDismiss}
      scrollBehavior='inside'
      size={size}
    >
      <div className='fixed inset-0 z-50 flex h-screen items-center justify-center'>
        <ModalContent
          className={cn('relative z-50 rounded bg-white shadow-lg', className)}
        >
          {children}
        </ModalContent>
      </div>
    </HeroUiModal>
  )
}

export { ModalBody, ModalFooter, ModalHeader }
